var map = {
	"./1.png": 9687,
	"./10.png": 4413,
	"./11.png": 9617,
	"./12.png": 8716,
	"./13.png": 1909,
	"./14.png": 1552,
	"./15.png": 5315,
	"./2.png": 5277,
	"./3.png": 275,
	"./4.png": 3826,
	"./5.png": 8545,
	"./6.png": 6890,
	"./7.png": 1261,
	"./8.png": 5922,
	"./9.png": 1696
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 488;